import React from 'react';
import NumericInput from 'react-numeric-input';
import style from './style.scss';

const MultiPickerCount = (PickerComponent) => {
  return (props) => {
    const { id, step = 1, min = 0, precision = 0, value = {}, onChange, ...rest } = props;
    return (
      <div className={style.picker}>
        <div>Add a item - <PickerComponent
          id=""
          value=""
          onChange={v => value[v] || onChange({ ...value, [v]: 0 })}
          {...rest}
        /></div>
        {Object.keys(value).map(subId => (<div key={subId} className={style.row}>
          <div className={style.key}>
            <PickerComponent
              key={subId}
              id={subId}
              value={subId}
              onChange={v => v === null
                ? onChange(Object.keys(value).reduce((s, i) =>
                  i !== subId ? ({ ...s, [i]: value[i] }) : s, {}))
                : value[v] !== undefined || onChange(Object.keys(value).reduce((s, i) =>
                  i !== subId ? ({ ...s, [i]: value[i] }) : s, { [v]: 0 }))
              }
              {...rest}
            />
          </div>
          <div className={style.value}>
            <NumericInput
              value={value[subId]}
              step={step}
              min={min}
              precision={precision}
              onChange={v => onChange({ ...value, [subId]: v })}
            />
          </div>
        </div>))}
      </div>);
  };
};

export default MultiPickerCount;



// WEBPACK FOOTER //
// ./app/components/MultiPickerCount/index.js